import api from './api';

export const getAllBlogs = async () => {
  const response = await api.get('/api/blogs');
  return response.data;
};

export const createBlog = async (blogData) => {
  const response = await api.post('/api/blogs', blogData, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
  });
  return response.data;
};

export const getBlogBySlug = async (slug) => {
    // If the API supports fetching by slug, use it. 
    // Otherwise, we might need to fetch all and filter, or update the backend.
    // Assuming backend support for now or following existing pattern.
    // The current Blog.jsx fetches ALL and filters client side (inefficient but legacy).
    // Let's stick to the current pattern for now but wrap it.
    const response = await api.get('/api/blogs');
    // If we want to move filtering here:
    // return response.data.data.find(b => b.slug === slug);
    return response.data; 
};
